import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'
import { PaymentType } from '../../enums/payment-type.enum'

export const incomeTemplateResponseSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  sortOrder: z.number(),
  amount: z.number().nullable(),
  currency: z.nativeEnum(Currency).nullable(),
  description: z.string().nullable(),
  paymentType: z.nativeEnum(PaymentType).nullable(),
  accountId: z.string().guid().nullable(),
  categoryId: z.string().guid().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type IncomeTemplateResponseDto = z.infer<typeof incomeTemplateResponseSchema>
